import * as React from 'react';
import * as I18n from 'i18n-js';
import LoadingBars from '@reverbdotcom/commons/dist/components/loading_bars';
import URLHelpers from './shared/url_helpers';
import Window from '@reverbdotcom/commons/dist/window_wrapper';

interface Props {
  onDraftSuccess(): void;
  order?: any;
}

export default function PacklinkLoadDraft({ onDraftSuccess, order }: Props) {
  const shipment = order.packlinkShipment;

  function redirectToPacklinkShipment() {
    Window.open(URLHelpers.packlinkShippingLabel(shipment.reference));
  }

  if (shipment?.reference) {
    onDraftSuccess();
    redirectToPacklinkShipment();
  }

  return (
    <div className="bg-white mlr-2">
      <div className="cms-text">
        <h2 className="align-center">{I18n.t('discovery.packlink.connectingToPacklink')}</h2>
        <div className="d-flex fx-align-center fx-justify-center height-vh-10 pb-4">
          <LoadingBars />
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/packlink_load_draft.tsx